(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const cleanDuplicateMailBlueErrors = (root) => {
    root.querySelectorAll('._field-wrapper').forEach((field) => {
      const errors = [...field.querySelectorAll('#email-error')];
      if (errors.length < 2) return;
      errors.forEach((error) => {
        if (error.querySelector('._error-inner')?.textContent?.trim() === 'Formulieren moeten een e-mailveld of een telefoonveld bevatten') {
          error.remove();
        }
      });
    });
  };
  document.querySelectorAll('[data-siti-newsletter-form], [data-siti-mailblue]').forEach((root) => {
    new MutationObserver(() => cleanDuplicateMailBlueErrors(root)).observe(root, { childList: true, subtree: true });
  });

  if (window.location.hash === '#sit-i-newsletter') {
    const target = document.getElementById('sit-i-newsletter');
    if (target) {
      const alignNewsletter = () => target.scrollIntoView({ block: 'start' });
      const observer = new MutationObserver(() => {
        if (target.querySelector('form')) {
          alignNewsletter();
          observer.disconnect();
        }
      });
      observer.observe(target, { childList: true, subtree: true });
      if (target.querySelector('form')) {
        alignNewsletter();
        observer.disconnect();
      }
      window.addEventListener('load', alignNewsletter, { once: true });
    }
  }

  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.siti-article-copy-link');
    if (!button) return;
    try {
      await navigator.clipboard.writeText(button.dataset.shareUrl);
      const status = button.closest('.social-share').querySelector('.siti-article-copy-status');
      if (status) status.textContent = button.dataset.copiedLabel;
    } catch (error) {
      window.prompt(button.getAttribute('aria-label'), button.dataset.shareUrl);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-lease-terms"] && !Shopify.designMode) return;
  try {
    
  const back = document.querySelector('[data-lease-terms-back]');
  const selected = new URLSearchParams(window.location.search).get('model');
  if (back && ['Opus', 'Care', 'Oris', 'Productadvies'].includes(selected)) {
    const url = new URL(back.href, window.location.origin);
    url.searchParams.set('model', selected);
    back.href = url.pathname + url.search;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-lease"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-siti-lease]').forEach(root => {
    const select = root.querySelector('[data-lease-model]');
    const allowed = ['Opus', 'Care', 'Oris'];
    const requested = new URLSearchParams(window.location.search).get('model');
    if (allowed.includes(requested)) select.value = requested;
    const update = () => {
      const url = new URL(root.dataset.contactUrl, window.location.origin);
      url.searchParams.set('aanvraag', 'lease');
      url.searchParams.set('model', allowed.includes(select.value) ? select.value : 'Productadvies');
      const campaign = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(key => {
        const value = campaign.get(key);
        if (value && /^[a-zA-Z0-9_.-]{1,80}$/.test(value)) url.searchParams.set(key, value);
      });
      url.hash = 'sit-i-contact';
      root.querySelectorAll('[data-lease-cta]').forEach(link => { link.href = url.pathname + url.search + url.hash; });
      const termsLink = root.querySelector('[data-lease-terms-link]');
      if (termsLink) {
        const termsUrl = new URL(termsLink.href, window.location.origin);
        termsUrl.searchParams.set('model', allowed.includes(select.value) ? select.value : 'Productadvies');
        termsLink.href = termsUrl.pathname + termsUrl.search + termsUrl.hash;
      }
    };
    select.addEventListener('change', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-legal-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-legal-page]').forEach((page) => {
    const content = page.querySelector('[data-legal-content]');
    const nav = page.querySelector('[data-legal-nav]');
    if (!content || !nav) return;
    const headings = [...content.querySelectorAll('h2, h3')].filter((heading) => heading.textContent.trim() && (heading.tagName === 'H2' || /^\d+[.)]/.test(heading.textContent.trim())));
    headings.forEach((heading, index) => {
      const id = `voorwaarde-${index + 1}`;
      if (!heading.id) heading.id = id;
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      nav.appendChild(link);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-mailblue-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-siti-mailblue]');
    if (!section) return;

    const params = new URLSearchParams(window.location.search);
    const english = document.documentElement.lang === 'en';
    const rawModel = params.get('model');
    const rawCourse = params.get('opleiding');
    const isReservation = params.get('aanvraag') === 'reservering';
    const isLease = params.get('aanvraag') === 'lease';
    const isReturn = params.get('onderwerp') === 'Sit-i-Return';
    const returnPhotos = section.querySelector('[data-siti-return-photos]');
    if (returnPhotos) returnPhotos.hidden = !isReturn;

    const removeHiddenModels = () => {
      const options = [...section.querySelectorAll('select option')];
      if (!options.length) return false;
      options
        .filter((option) => ['Forma', 'Athlete'].includes(option.value))
        .forEach((option) => option.remove());
      options
        .filter((option) => option.value === 'Care Oris')
        .forEach((option) => { option.textContent = 'Oris'; });
      return true;
    };

    if (!removeHiddenModels()) {
      const hiddenModelsObserver = new MutationObserver(() => {
        if (removeHiddenModels()) hiddenModelsObserver.disconnect();
      });
      hiddenModelsObserver.observe(section, { childList: true, subtree: true });
    }

    const addReturnOption = () => {
      const existingOption = section.querySelector('input[name="field[3]"][value="Sit-i Return"]');
      if (existingOption) return true;

      const otherOption = section.querySelector('input[name="field[3]"][value="Iets anders"]');
      const otherRow = otherOption?.closest('._row._checkbox-radio');
      if (!otherRow) return false;

      const returnId = 'field_3Sit-i Return';
      const returnRow = document.createElement('div');
      returnRow.className = '_row _checkbox-radio';
      returnRow.innerHTML = `
        <input id="${returnId}" type="radio" name="field[3]" value="Sit-i Return" data-name="waar_gaat_je_vraag_over">
        <span><label for="${returnId}">Sit-i Return</label></span>
      `;
      otherRow.before(returnRow);
      return true;
    };

    if (!addReturnOption()) {
      const returnOptionObserver = new MutationObserver(() => {
        if (addReturnOption()) returnOptionObserver.disconnect();
      });
      returnOptionObserver.observe(section, { childList: true, subtree: true });
    }

    const modelNames = {
      'Athlete-Pro': 'Sit-i Athlete · Pro',
      Care: 'Sit-i Care',
      'Care-Pro': 'Sit-i Care · Pro',
      Oris: 'Sit-i Oris',
      Opus: 'Sit-i Opus',
      'sit-i-dynamic-chair-athlete-pro': 'Sit-i Athlete · Pro',
      'sit-i-dynamic-chair-care': 'Sit-i Care',
      'sit-i-dynamic-chair-pro': 'Sit-i Care · Pro',
      'sit-i-dynamic-chair-care-oris': 'Sit-i Oris',
      'sit-i-dynamic-chair-oris': 'Sit-i Oris',
      'sit-i-dynamic-chair-opus': 'Sit-i Opus'
    };
    const genericAdvice = rawModel === 'Productadvies';
    const modelName = rawModel && !genericAdvice ? (modelNames[rawModel] || rawModel.replaceAll('-', ' ')) : 'Productadvies';
    const modelValues = {
      'athlete-pro': 'Athlete Pro',
      care: 'Care',
      'care-pro': 'Care Pro',
      oris: 'Care Oris',
      opus: 'Opus',
      'sit-i-dynamic-chair-athlete-pro': 'Athlete Pro',
      'sit-i-dynamic-chair-care': 'Care',
      'sit-i-dynamic-chair-pro': 'Care Pro',
      'sit-i-dynamic-chair-care-oris': 'Care Oris',
      'sit-i-dynamic-chair-oris': 'Care Oris',
      'sit-i-dynamic-chair-opus': 'Opus'
    };
    const modelValue = rawModel ? modelValues[rawModel.toLowerCase()] : '';
    const context = section.querySelector('[data-siti-model-context]');
    const modelNameTarget = section.querySelector('[data-siti-model-name]');

    if (rawModel && context && modelNameTarget) {
      modelNameTarget.textContent = genericAdvice ? (english ? 'your application' : 'jouw toepassing') : modelName;
      context.hidden = false;
      if (isLease) {
        section.querySelector('[data-siti-context-kicker]').textContent = 'Sit-i Lease · Woerden';
        section.querySelector('[data-siti-context-title]').textContent = english ? 'Lease consultation for' : 'Leaseconsult voor';
        if (genericAdvice) modelNameTarget.textContent = english ? 'the model that suits you' : 'een passend model';
        section.querySelector('[data-siti-context-description]').textContent = english
          ? 'Request personal contact for a consultation and trial in Woerden. You are not booking or paying through this form.'
          : 'Vraag persoonlijk contact aan voor een consult en test in Woerden. Je boekt of betaalt niets via dit formulier.';
      }
      if (isReservation) {
        section.querySelector('[data-siti-context-kicker]').textContent = section.dataset.reservationKicker;
        section.querySelector('[data-siti-context-title]').textContent = section.dataset.reservationTitle;
        section.querySelector('[data-siti-context-description]').textContent = section.dataset.reservationDescription;
      }
    }

    let trackedStart = false;
    let trackedSuccess = false;
    const trackConfirmation = () => {
      const confirmation = section.querySelector('._form-thank-you');
      if (trackedSuccess || !confirmation || !confirmation.getClientRects().length) return;
      if (getComputedStyle(confirmation).visibility === 'hidden') return;
      trackedSuccess = true;
      window.dataLayer?.push({ event: 'siti_advice_confirmed', product_name: modelName });
      window.Shopify?.analytics?.publish('sit_i:advice_confirmed', { product_name: modelName });
    };
    new MutationObserver(trackConfirmation).observe(section, { childList: true, subtree: true, attributes: true });
    const enhanceForm = () => {
      const form = section.querySelector('form[action*="activehosted.com"]');
      if (!form || form.dataset.sitiEnhanced) return Boolean(form);

      const adviceOption = form.querySelector('input[type="radio"][value="Advies over een model"]');
      const academyOption = form.querySelector('input[type="radio"][value="Sit-i Academy"]');
      const modelSelect = form.querySelector('select[name="field[5]"]');
      const workfieldSelect = form.querySelector('select[name="field[6]"]');
      const topicOptions = [...form.querySelectorAll('input[type="radio"][name="field[3]"]')];
      const message = form.querySelector('textarea[name="field[4]"]');
      if (!topicOptions.length || !message) return false;

      form.dataset.sitiEnhanced = 'true';
      const modelField = modelSelect?.closest('._form_element');
      const workfieldField = workfieldSelect?.closest('._form_element');
      modelField?.classList.add('siti-mailblue__conditional-field');
      workfieldField?.classList.add('siti-mailblue__conditional-field');

      const setFieldVisibility = (field, control, visible) => {
        if (!field || !control) return;
        field.hidden = !visible;
        control.disabled = !visible;
        control.required = visible;
        control.setAttribute('aria-required', visible ? 'true' : 'false');
        if (!visible) control.value = '';
      };

      const updateConditionalFields = () => {
        const selectedTopic = form.querySelector('input[type="radio"][name="field[3]"]:checked')?.value || '';
        setFieldVisibility(
          modelField,
          modelSelect,
          ['Sit-i Dynamic Chair', 'Advies over een model'].includes(selectedTopic)
        );
        setFieldVisibility(
          workfieldField,
          workfieldSelect,
          ['Sit-i Dynamic Chair', 'Sit-i Academy', 'Advies over een model', 'Samenwerking'].includes(selectedTopic)
        );
      };

      topicOptions.forEach((option) => option.addEventListener('change', updateConditionalFields));

      if (rawModel && adviceOption) {
        adviceOption.checked = true;
        const applyModelValue = () => {
          if (!modelSelect || !modelValue || ![...modelSelect.options].some((option) => option.value === modelValue)) return;
          modelSelect.value = modelValue;
          modelSelect.dispatchEvent(new Event('change', { bubbles: true }));
        };
        [0, 250, 750, 1500].forEach((delay) => window.setTimeout(applyModelValue, delay));
        if (!message.value.trim()) message.value = isLease
          ? (english
            ? `I would like to request a Sit-i Lease consultation in Woerden${genericAdvice ? '' : ` for ${modelName}`}. My question: `
            : `Ik vraag graag een Sit-i Lease-consult aan in Woerden${genericAdvice ? '' : ` voor ${modelName}`}. Mijn vraag: `)
          : isReservation
          ? `${section.dataset.reservationMessage} ${modelName}. `
          : genericAdvice
            ? (english ? 'I would like product advice. My application or question: ' : 'Ik ontvang graag productadvies. Mijn toepassing of vraag: ')
            : (english ? `I would like advice about ${modelName}. My application or question: ` : `Ik ontvang graag advies over ${modelName}. Mijn toepassing of vraag: `);
      }
      if (rawCourse && academyOption) {
        academyOption.checked = true;
        academyOption.dispatchEvent(new Event('change', { bubbles: true }));
        if (!message.value.trim()) {
          message.value = english ? `I would like up-to-date information about ${rawCourse.replaceAll('-', ' ')}. My question: ` : `Ik ontvang graag actuele informatie over ${rawCourse.replaceAll('-', ' ')}. Mijn vraag: `;
        }
      }
      if (isReturn) {
        const returnOption = form.querySelector('input[name="field[3]"][value="Sit-i Return"]');
        if (returnOption) {
          returnOption.checked = true;
          returnOption.dispatchEvent(new Event('change', { bubbles: true }));
          if (!message.value.trim()) message.value = english
            ? ['I would like to discuss Sit-i Return for my chair.', '', 'Model / configuration: ', 'First delivery date (if known): ', 'Serial number (if known): ', 'Condition and any damage: ', 'Missing or replaced parts: ', 'My question: '].join('\n')
            : ['Ik wil graag Sit-i Return voor mijn stoel bespreken.', '', 'Model / uitvoering: ', 'Datum eerste levering (indien bekend): ', 'Serienummer (indien bekend): ', 'Staat en eventuele schade: ', 'Ontbrekende of vervangen onderdelen: ', 'Mijn vraag: '].join('\n');
        }
      }
      updateConditionalFields();

      form.addEventListener('focusin', () => {
        if (trackedStart) return;
        trackedStart = true;
        window.dataLayer?.push({ event: 'siti_advice_start', product_name: modelName });
        window.Shopify?.analytics?.publish('sit_i:advice_start', { product_name: modelName });
      });

      form.addEventListener('submit', () => {
        window.dataLayer?.push({ event: 'siti_advice_submit_attempt', product_name: modelName });
        window.Shopify?.analytics?.publish('sit_i:advice_submit_attempt', { product_name: modelName });
      });

      return true;
    };

    if (enhanceForm()) return;
    const observer = new MutationObserver(() => {
      if (enhanceForm()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-model-overview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-siti-model-chooser]').forEach((chooser) => {
    const section = chooser.closest('.siti-models');
    const cards = [...section.querySelectorAll('[data-model-card]')];
    const selections = {};
    const result = chooser.querySelector('[data-choice-result]');

    const update = () => {
      let visible = 0;
      cards.forEach((card) => {
        const matches = Object.entries(selections).every(([group, value]) => {
          if (group === 'field' && value === 'care') return ['care', 'dental'].includes(card.dataset.field);
          return card.dataset[group] === value;
        });
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      result.textContent = visible === 0
        ? chooser.dataset.none
        : visible === 1 ? chooser.dataset.one : chooser.dataset.many.replace('[count]', visible);
    };

    chooser.querySelectorAll('[data-choice-group] button').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-choice-group]').dataset.choiceGroup;
        const alreadyActive = button.getAttribute('aria-pressed') === 'true';
        button.closest('[data-choice-group]').querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        if (alreadyActive) delete selections[group];
        else {
          selections[group] = button.dataset.choice;
          button.setAttribute('aria-pressed', 'true');
        }
        update();
      });
    });

    chooser.querySelector('[data-choice-reset]').addEventListener('click', () => {
      Object.keys(selections).forEach((key) => delete selections[key]);
      chooser.querySelectorAll('[aria-pressed]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
      update();
    });
    const initialField = new URLSearchParams(window.location.search).get('werkveld');
    if (['sport', 'care', 'dental', 'work'].includes(initialField)) {
      const button = chooser.querySelector(`[data-choice-group="field"] [data-choice="${initialField}"]`);
      button?.click();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-product-compare"] && !Shopify.designMode) return;
  try {
    
  const showSitIComparison = () => {
    const comparison = document.querySelector('#vergelijk-modellen .siti-pdp-comparison');
    if (comparison) comparison.open = true;
  };
  if (window.location.hash === '#vergelijk-modellen') showSitIComparison();
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a');
    if (link && link.hash === '#vergelijk-modellen' && link.pathname === window.location.pathname) showSitIComparison();
  });

  // Keep an opened comparison when browser Back reloads rather than caches this page.
  const sitIComparisonReturnKey = 'sit-i-product-comparison-return';
  document.addEventListener('click', event => {
    const link = event.target.closest?.('#vergelijk-modellen a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.origin !== location.origin || !link.pathname.includes('/products/') || link.pathname === location.pathname) return;
    try { sessionStorage.setItem(sitIComparisonReturnKey, JSON.stringify({path:location.pathname, search:location.search, y:scrollY, time:Date.now()})); } catch {}
  });
  const restoreSitIComparison = () => {
    let state;
    try { state = JSON.parse(sessionStorage.getItem(sitIComparisonReturnKey) || 'null'); } catch { return; }
    if (!state || state.path !== location.pathname || state.search !== location.search || !Number.isFinite(state.y) || state.y < 0 || Date.now() - state.time > 1800000) return;
    showSitIComparison();
    const restorePosition = () => {
      const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();
      Promise.race([fontsReady, new Promise(resolve => setTimeout(resolve, 2000))]).then(() => {
        requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo({top:state.y,left:0,behavior:'instant'})));
      });
    };
    if (document.readyState === 'complete') restorePosition();
    else window.addEventListener('load', restorePosition, {once:true});
  };
  if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') restoreSitIComparison();
  window.addEventListener('pageshow', event => { if (event.persisted) restoreSitIComparison(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siti-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-siti-advice-cta]');
    if (!link) return;
    window.dataLayer?.push({
      event: 'siti_advice_click',
      product_name: link.closest('.siti-pdp')?.querySelector('#siti-product-title')?.textContent.trim() || document.title,
      destination: link.href
    });
  });

  const mobileCta = document.querySelector('[data-siti-mobile-cta]');
  const heroActions = document.querySelector('.siti-pdp-hero .siti-pdp-actions');
  if (mobileCta && heroActions && 'IntersectionObserver' in window) {
    const mobileCtaObserver = new IntersectionObserver(([entry]) => {
      mobileCta.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.15 });
    mobileCtaObserver.observe(heroActions);
  }

  } catch(e) { console.error(e); }
})();
})();
